<template>
  <div class="modal-overlay" v-if="showSubscribeErrorModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close" aria-label="Close">&times;</button>
      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
        <h3 class="error-title">Oh No! An Error Occured</h3>
      </div>
      <div class="modal-body">
        <p class="error-message">
          <template v-if="subscribeErrorReason">
            You were unable to subscribe to <span class="brand">Sports Hub</span> due to [{{ subscribeErrorReason }}].
          </template>
          <template v-else>
            {{ subscribeErrorMessage || 'You were unable to subscribe to Sports Hub.' }}
          </template>
        </p>
        <p class="error-hint">Please try again later.</p>
        <button class="close-action-btn" @click="close">CLOSE</button>
        <p class="terms-text">By continuing you agree to the <a href="#" class="terms-link" @click.prevent>terms & conditions.</a></p>
        <p class="data-charges">Data charges may apply.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import modalMixin from '@/mixins/modalMixin'

export default {
  name: 'SubscribeErrorModal',
  mixins: [modalMixin], 
  computed: {
    ...mapState(['showSubscribeErrorModal', 'subscribeErrorMessage', 'subscribeErrorReason'])
  },
  methods: {
    ...mapMutations(['closeAllModals'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.error-title {
  font-size: 18px;
  font-weight: 700;
  color: $brand-dark;
  margin: 0 0 $space-base 0;
  text-align: center;
}

.modal-body {
  text-align: center;
}

.error-message {
  color: $brand-dark;
  font-size: 15px;
  font-weight: 400;
  margin: 0 0 $space-sm 0;
  line-height: 1.5;
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;

  .brand {
    color: $brand-red;
    font-weight: 700;
  }
}

.error-hint {
  color: $brand-red;
  font-size: 15px;
  font-weight: 400;
  margin: 0 0 $space-lg 0;
}

.close-action-btn {
  @include primary-btn;
  margin-bottom: $space-base;
}

.terms-text {
  font-size: 11px;
  color: $gray-500;
  text-align: center;
  margin: 0 0 6px 0;
  line-height: 1.4;
}

.terms-link {
  color: $brand-dark;
  text-decoration: underline;
  cursor: pointer;
}

.data-charges {
  font-size: 11px;
  color: $gray-500;
  text-align: center;
  margin: 0;
}
</style>
